/**
 * ContractDrawerAddDocumentAction public entry point.
 * View-only — the parent owns the press handler and discard-dialog state.
 * @module features/contracts/components/ContractDrawerAddDocumentAction
 */
export { default } from "./ContractDrawerAddDocumentActionView";
